// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"550":"ec25392c","980":"845d6119"}[chunkId] + ".chunk.css";
};